import {isEmpty} from "lodash"

export default (target, placeholders) => {
  if (isEmpty(placeholders)) return target

  const replacePattern = new RegExp(Object.keys(placeholders)
    .map((item) => `{{${item}}}`)
    .join("|"), "gi")

  return target.replace(replacePattern, (match) => {
    return placeholders[match.toLowerCase()
      .replace("{{", "")
      .replace("}}", "")]
  })
}
